module.exports = __webpack_public_path__ + "1b9cefd3ef5d650c5503676930ad2603.svg";